import { Injectable, signal } from '@angular/core';
import { OnDestroy } from '@angular/core';
@Injectable({
  providedIn: 'root'
})
export class BrowserExtensionService implements OnDestroy {

  isExtensionInstalled = signal<boolean>(false);
  private checkExtensionInterval?: number;
  private readonly EXTENSION_CHECK_INTERVAL = 2000; // Check every 2 seconds

  constructor() {
    this.startExtensionPolling();
  }

  ngOnDestroy(): void {
    if (this.checkExtensionInterval) {
      clearInterval(this.checkExtensionInterval);
    }
  }

  /**
   * @description Polls for extension installation every 2 seconds.
  */
  private startExtensionPolling() {
    if (this.checkExtensionInterval) {
      clearInterval(this.checkExtensionInterval);
    }

    this.checkExtensionInterval = window.setInterval(async () => {
      const installed = await this.checkIfExtensionInstalled();
      if (installed) {
        this.isExtensionInstalled.set(true);
      }
      else {
        this.isExtensionInstalled.set(false);
      }
    }, this.EXTENSION_CHECK_INTERVAL);
  }

  /**
   * Check if extension is installed.
   * This is a best-effort check - the extension might not respond immediately.
   * 
   * Uses window.postMessage to ping the content script.
   * 
   * @returns Promise that resolves to true if extension appears to be installed
   */
  private async checkIfExtensionInstalled(): Promise<boolean> {
    try {
      return new Promise<boolean>((resolve) => {
        // Set up listener for response
        const messageHandler = (event: MessageEvent) => {
          if (event.origin !== window.location.origin) {
            return;
          }

          if (event.data?.type === 'EXTENSION_PONG') {
            window.removeEventListener('message', messageHandler);
            resolve(event.data.ok === true);
          }
        };

        window.addEventListener('message', messageHandler);

        // Send ping to content script
        window.postMessage({
          type: 'EXTENSION_PING'
        }, window.location.origin);

        // Timeout after 2 seconds
        setTimeout(() => {
          window.removeEventListener('message', messageHandler);
          resolve(false);
        }, 2000);
      });
    } catch {
      return false;
    }
  }

  goToExtensionUrl(): void {
    window.open('https://chromewebstore.google.com/detail/mcffijfdpdgpbkgbmmahiacocfajocjj?utm_source=item-share-cb', '_blank');
  }
}

